import React, { useMemo, useState } from "react";
import { AppPage, MimaButton, MimaTable } from "../../components";
import constant from "../../utils/constant";
import moment from "moment";
import { AnimatePresence } from "framer-motion";
import { CreateNewsContainer, DeleteNewsContainer } from "../../containers";
import MimaOptionMenu from "../../components/OptionMenu/";
import { adminStore } from "../../stores";

const News = ({
  closeModal,
  goToCreateNews,
  createNewsModal,
  onLimitChange,
  data,
  currentPage,
  setCurrentPage,
  limit,
  isLoading,
  isFetching,
  setSearchQuery,
  goToViewMore,
  goToUpdateNews,
  goToDeleteNews,
  deleteNewsModal,
}) => {
  const tableData = useMemo(() => {
    if (data?.status === constant.Success) {
      const news = data?.data?.news || [];

      return news.filter((item) => item.status === true);
    }
    return [];
  }, [data]);

  const tableColumns = [
    {
      Header: "Date Created",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const date = cell.row.original.createdAt;
        return <span>{moment(date).format("DD/MM/YYYY HH:mm a")}</span>;
      },
    },
    {
      Header: "Title",
      accessor: "title",
    },
    {
      Header: "Summary",
      accessor: "summary",
    },
    {
      Header: "Action Call",
      accessor: `action.buttonTitle`,
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        const item = cell.row.original;
        return (
          <MimaOptionMenu
            options={[
              { label: "View More", value: "View More" },
              { label: "Update News", value: "Update News" },
              { label: "Delete News", value: "Delete News" },
            ]}
            onOptionSelected={(option) => {
              adminStore.setSingleNews(item);
              if (option.value === "View More") {
                goToViewMore();
              } else if (option.value === "Update News") {
                goToUpdateNews();
              } else if (option.value === "Delete News") {
                goToDeleteNews();
              }
            }}
          />
        );
      },
    },
  ];
  return (
    <AppPage pageTitle="News">
      <MimaButton title="Create News" mt={3} mb={3} onClick={goToCreateNews} />
      <MimaTable
        tableData={tableData}
        tableColumns={tableColumns}
        searchPlaceholder="Search News"
        searchVariant="wide"
        totalItems={data?.data?.totalCounts}
        onLimitChange={onLimitChange}
        isLoading={isLoading}
        isFetching={isFetching}
        limit={limit}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setSearchQuery={setSearchQuery}
      />

      {(createNewsModal || deleteNewsModal) && (
        <div className="modal">
          <AnimatePresence>
            {createNewsModal && <CreateNewsContainer closeModal={closeModal} />}
            {deleteNewsModal && <DeleteNewsContainer closeModal={closeModal} />}
          </AnimatePresence>
        </div>
      )}
    </AppPage>
  );
};
export default News;
